// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';

const getClientChannelQueueContent = wrapWithNetworkError(
  function getChannelContent(token: string, clientId: Id, channelName: string) {
    const fetchUrl = getEndpointUrl(
      `/moderate/content/client/${clientId}/channel/${channelName}/queue`
    );
    const fetchOptions = {
      headers: {
        Authorization: token,
      },
    };

    return fetch(fetchUrl, fetchOptions)
      .then(response => checkResponse(response))
      .then(response => {
        if (response.status === 204) {
          return [];
        }

        return response.json();
      })
      .then(
        (json: GetContentResponse) => (Array.isArray(json) ? json : [json])
      );
  }
);

export default getClientChannelQueueContent;



// WEBPACK FOOTER //
// ./src/containers/channels/getClientModerationContentApi.js